<template>
    <div class="d-flex align-items-stretch">
        <parens
            v-if="showParens"
            left />
        <div class="d-flex align-items-center">
            {{ display }}
        </div>
        <parens v-if="showParens" />
    </div>
</template>

<script>
    import base from "./_baseExpression.vue";
    import { isModuleRegistered } from "SharedStores/util";
    import { PROGRAM_TYPES, PROGRAM_NAMESPACE } from "SharedStores/Program/programStore";
    import { PROJECT_TYPES, PROJECT_NAMESPACE } from "SharedStores/Project/projectStore";
    import { isEnvelopeInStatus, ENVELOPE_STATUS } from "ESignatures/eSignatureConstants";
    import { BOOLEAN_VALUE } from "Formula/evaluators/boolean";
    import { KEYS, NAMESPACE } from "./i18n/envelopeCompleted.i18n";
    import { mapI18n } from "Util/i18n";

    export default {
        extends: base,
        computed: {
            ...mapI18n({ ...KEYS }, NAMESPACE),
            display() {
                if (this.expression.PublicEnvelopeDefinitionId) {
                    if (!isModuleRegistered(PROGRAM_NAMESPACE, this.$store.state)) {
                        throw Error("program store not registered");
                    }
                    const envelopeDefinition = this.$store.getters[PROGRAM_TYPES.getters.getEnvelopeDefinitionFromId](
                        this.expression.PublicEnvelopeDefinitionId
                    );
                    let valueStr = "";
                    if (isModuleRegistered(PROJECT_NAMESPACE, this.$store.state)) {
                        const envelope = this.$store.getters[PROJECT_TYPES.getters.getEnvelopeFromDefinitionId](
                            envelopeDefinition.PublicId
                        );
                        if (envelope) {
                            valueStr = `: ${isEnvelopeInStatus(envelope, ENVELOPE_STATUS.Completed) ? "Yes" : "No"}`;
                        } else if (this.expression.usingDefault) {
                            const yesOrNo = this.expression.ConstantValue === BOOLEAN_VALUE.false ? "No" : "Yes";
                            valueStr = `: [${yesOrNo}]`;
                        } else {
                            return this.localizedStringWithParams(KEYS.envelopeCompletedEnvelopeSelectedError, {
                                envelopeDefinitionName: envelopeDefinition.Name
                            });
                        }
                    }
                    return this.localizedStringWithParams(KEYS.envelopeCompletedEnvelopeSelected, {
                        envelopeDefinitionName: envelopeDefinition.Name,
                        valueStr: valueStr
                    });
                }
                return this.envelopeCompletedPlaceholder;
            },
            showParens() {
                //Show Parens only if Envelope Definition is not set.
                return this.expression.PublicEnvelopeDefinitionId == null;
            }
        },
        methods: {
            localizedStringWithParams(key, params) {
                return this.res({ namespace: NAMESPACE, key: key, values: params });
            }
        }
    };
</script>
